import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a840889bedae70014976e1e_1787317251772_b7576855/tubenexa/src/app/royalties/page.tsx");
